import React from 'react';
import PropTypes from 'prop-types';
import LinkButton from "../../shared/components/LinkButton";
import {PsRoutes} from "../../shared/routing/Routes";
import {I18nUtils} from "../../../i18n/I18nUtils";
import RouterUtils from "../../shared/routing/RouterUtils";

export default class SchemeDocumentRow extends React.Component {

    render() {
        const { schemeDocument } = this.props;
        let documentNames = '';
        for (let i = 0; i < schemeDocument.document_types.length; i++){
          if (documentNames.length > 0){
            documentNames += ', ';
          }
          documentNames += schemeDocument.document_types[i].name;
        }
        return (
            <tr>
                <td><strong>{schemeDocument.name}</strong></td>
                <td>{documentNames}</td>
                <td>
                    <LinkButton to={RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_DOCUMENTS_SCHEMES_DETAIL, {id: schemeDocument.id})} text={I18nUtils.tr('TR_VER_FICHA')} className={'btn-block btn-sm'}/>
                </td>
            </tr>
        );
    }

}


SchemeDocumentRow.propTypes = {
    schemeDocument: PropTypes.any.isRequired,
};

SchemeDocumentRow.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/documents/components/SchemeDocumentRow.js